import { template } from 'underscore';
import Backbone from 'backbone';
export default Backbone.View.extend({
  initialize(className = '') {
    this.className = className;
    var alreadyVisible = $('.' + className).length;
    if (!alreadyVisible) {
      this.render();
    }
  },
  events: {},
  template(className) {
    return `
    <div class="${className}">
    </div>
        `;
  },
  render() {
    $('body').append(this.template(this.className));
    document.getElementsByClassName(this.className)[0];
  }
});
